import { Injectable } from '@angular/core';
import { Observable, defer, of } from 'rxjs';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import {
    AllPermissionsLoaded,
    AllPermissionsRequested,
    PermissionActionTypes
} from '../_actions/permission.actions';

@Injectable()
export class PermissionEffects {
    @Effect()
    loadAllPermissions$ = this.actions$.pipe(
        ofType<AllPermissionsRequested>(PermissionActionTypes.AllPermissionsRequested),
        // Permissions not used — always resolve empty
    );

    @Effect()
    init$: Observable<Action> = defer(() => of(new AllPermissionsLoaded({ permissions: [] })));

    constructor(private actions$: Actions) {}
}